
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import hexsha1 from '../../../static/js/hex-sha1'
import {eventBus} from '../../eventbus'
export default {
name: 'login',
components: {XInput, Group, XButton, Toast},
data () {
return {
$vue: '',
usercode: '',
password: '',
code: '',
position: 'bottom',
errorText: '',
showPositionValue: false
}
},
methods: {
login () {

this.$validator.validateAll().then((result) => {
if (!result) {
if (this.error.has('username')) {
this.showPosition(this.error.first('username'))
return
}
if (this.error.has('password')) {
this.showPosition(this.error.first('password'))
return
}
}

eventBus.$emit('showLoading', true, '登陆中')

let psd = hexsha1.hex_sha1(this.password)
let KEYDATE = 'qq12345678mfw' + this.usercode + ',mfw,' + psd + 'QQ98765423mfw' + ',mfw,' + this.code

let params = new URLSearchParams()
params.append('KEYDATA', KEYDATE)
this.$http.post(this.$vue.getData('LOGIN_URL'), params).then(suc => {
if (suc.data.result === 'success') {

localStorage.setItem('JWT_TOKEN', suc.data.JWD_TOKEN)
localStorage.setItem('ID', suc.data.USER_ID)

if (suc.data.STATUS === '-3') {
localStorage.setItem('PHONE', this.usercode)
this.$router.push({name: 'SubmitInformation'})
} else {
this.$router.push({path: '/doctor/index'})
}
} else {
this.loginErr(suc.data.result)
}
}, err => {
console.log(err.data)
this.loginErr()
})

eventBus.$emit('showLoading', false)
})
},
forget () {
this.$router.push({name: 'Forget', params: {usercode: this.usercode}})
},
loginErr (errInfo) {
let text = ''
switch (errInfo) {
case 'nullcode': text = '验证码错误'
break
case 'codeerror': text = '验证码错误'
break
case 'userlocked': text = '用户被锁定'
break
case 'sysAuditing': text = '请等待管理员审核'
break
case 'userClosed': text = '用户被禁用'
break
case 'usererror': text = '用户名或密码错误'
break
case 'error': text = '缺少参数'
break
default : text = '登陆失败，请稍后再试'
break
}
this.showPosition(text)
},
showPosition (text) {
this.errorText = text
this.showPositionValue = true
}
},
beforeMount () {
this.$vue = this
}
}



// WEBPACK FOOTER //
// ./src/components/login/login.vue